"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startsWithCaseInsensitive = exports.includesCaseInsensitive = exports.equalsCaseInsensitive = exports.endsWithCaseInsensitive = void 0;
var _ramda = require("ramda");
var compareCaseInsensitive = function compareCaseInsensitive(a, b) {
  return a.localeCompare(b, undefined, {
    sensitivity: 'accent'
  });
};

// https://stackoverflow.com/a/2140723/1945651
// https://stackoverflow.com/questions/2140627/how-to-do-case-insensitive-string-comparison
var equalsCaseInsensitive = exports.equalsCaseInsensitive = (0, _ramda.curry)(function (a, b) {
  return typeof a === 'string' && typeof b === 'string' ? compareCaseInsensitive(a, b) === 0 : a === b;
});
var includesCaseInsensitive = exports.includesCaseInsensitive = function includesCaseInsensitive(value, values) {
  return (0, _ramda.any)(equalsCaseInsensitive(value), values);
};
var endsWithCaseInsensitive = exports.endsWithCaseInsensitive = (0, _ramda.curry)(function (value, suffix) {
  return equalsCaseInsensitive((0, _ramda.takeLast)(suffix.length, value), suffix);
});
var startsWithCaseInsensitive = exports.startsWithCaseInsensitive = (0, _ramda.curry)(function (value, prefix) {
  return equalsCaseInsensitive((0, _ramda.take)(prefix.length, value), prefix);
});